import { useParams } from '@tanstack/react-router';
import { RubricDetailContainer } from '../../contexts/rubrics';

export function RubricDetailPage() {
  const { rubricId } = useParams({ from: '/authenticated/orgs/$orgSlug/rubrics/$rubricId/' });
  return <RubricDetailContainer rubricId={rubricId} />;
}
